export default __webpack_public_path__ + "static/media/Mouse.686e4384.svg";